import type { RiskRecognitionHighlight } from '@cobliteam/api-lib/src/dashboard/riskRecognitions/Types';
import { cn } from '@cobliteam/ui/utils';
import type { TransitionEvent } from 'react';
import RiskRecognitionCardContent from './RiskRecognitionCardContent';

interface RiskRecognitionCardProps {
  highlight: RiskRecognitionHighlight;
  actionLabel?: string | null;
  dismissLabel?: string | null;
  // `true` enquanto o card anima a saída (dismiss). Mantém o nó montado até o transitionend.
  isExiting: boolean;
  // O card cola no painel direito de 440px; quando ele colapsa, desliza para a borda da viewport.
  isRightPanelHidden: boolean;
  onDismiss: () => void;
  onAction: () => void;
  onTransitionEnd: (event: TransitionEvent<HTMLDivElement>) => void;
}

// Card flutuante de /monitoring: posiciona + anima a entrada/saída; o conteúdo é o card compartilhado.
const RiskRecognitionCard = ({ highlight, actionLabel, dismissLabel, isExiting, isRightPanelHidden, onDismiss, onAction, onTransitionEnd }: RiskRecognitionCardProps) => (
  <div
    className={cn(
      'fixed bottom-4 z-[1003] w-[352px] max-w-[calc(100vw-2rem)] transition-[opacity,transform,right] duration-200 ease-out motion-reduce:duration-[1ms]',
      isRightPanelHidden ? 'right-4' : 'right-[calc(440px+1rem)]',
      isExiting && 'pointer-events-none translate-y-2 scale-[0.98] opacity-0'
    )}
    onTransitionEnd={onTransitionEnd}
  >
    <RiskRecognitionCardContent highlight={highlight} actionLabel={actionLabel} dismissLabel={dismissLabel} onDismiss={onDismiss} onAction={onAction} />
  </div>
);

export default RiskRecognitionCard;
